// extracted by mini-css-extract-plugin
module.exports = {"root":"HistoryScene_root__QXhe6"};